export { LayoutComponent } from './layout.component';



// WEBPACK FOOTER //
// ./src/app/layouts/index.ts